const initState = {
    /// README: IMPORTANT (do not remove without authority)
    proid: null,
    snagDetail: null,
    floorMeta: null,

    /// README: NEW PROJECT PAGE
    isProjectCreating: false,
    isFilesAdded: false,
    isProjectCreated: false,

    /// README: UPLOAD MORE FILES IN PROJECT
    isMoreFilesAdding: false,
    isMoreFilesAdded: false,
    isMoreFilesSynced: false,

    /// README: NEW TAG
    isTagCreating: false,
    isTagCreated: false,

    /// README: PROJECT PROFILE MODAL
    isProjectUpdating: false,
    isProjectUpdated: false,

    /// README: PROJECT API CALL
    papiMessage: "",
    papiIsDoneAndSent: false,
    showPapiLoader: false,
    papid: -1,
    isReportCreating: false,
    isReportCreated: false,
    isMemberRemoved: false,
    isMemberAdded: false,

    // README: PROJECT DELETE
    isProjectDeleting: false,
    isProjectDeleted: true,
}

const projectReducer = (state = initState, action) => {
    /// README: PROJECT SETTING AND INITIALIZE
    if (action.type === "SET_CURRENT_PROJECT_ID") {
        return {
            ...state,
            proid: action.proid,
        }
    }
    else if (action.type === "SET_CURRENT_SNAG_DETAIL") {
        return {
            ...state,
            snagDetail: action.snagDetail,
        }
    }
    else if (action.type === "SET_CURRENT_FLOOR_META") {
        return {
            ...state,
            floorMeta: action.floorMeta,
        }
    }
    else if (action.type === "SET_CURRENT_SNAG_DETAIL_WITH_FLOOR_META") {
        return {
            ...state,
            snagDetail: action.snagDetail,
            floorMeta: action.floorMeta,
        }
    }
    else if (action.type === "CLEAR_PROJECT_ID") {
        return {
            ...state,
            proid: null,
        }
    }

    /// README: NEW PROJECT CREATION
    else if (action.type === "OPEN_NEW_PROJECT_PAGE") {
        return {
            ...state,
            isProjectCreating: false,
            isFilesAdded: false,
            isProjectCreated: false,
            proid: null,
        }
    }
    else if (action.type === "ADD_NEW_PROJECT") {
        return {
            ...state,
            isProjectCreating: true,
        }
    }
    else if (action.type === "FILES_ADDED") {
        return {
            ...state,
            isFilesAdded: true,
        }
    }
    else if (action.type === "NEW_PROJECT_ADDED") {
        return {
            ...state,
            isProjectCreating: false,
            isFilesAdded: false,
            isProjectCreated: true,
            proid: action.proid
        }
    }

    /// README: PROJECT UPDATING
    else if (action.type === "OPEN_UPLOAD_FILES_MODAL") {
        return {
            ...state,
            isMoreFilesAdding: false,
            isMoreFilesAdded: false,
            isMoreFilesSynced: false,
        }
    }
    else if (action.type === "ADD_MORE_FILES") {
        return {
            ...state,
            isMoreFilesAdding: true,
        }
    }
    else if (action.type === "MORE_FILES_ADDED") {
        return {
            ...state,
            isMoreFilesAdded: true,
        }
    }
    else if (action.type === "MORE_FILES_UPLOADED") {
        return {
            ...state,
            isMoreFilesAdding: false,
            isMoreFilesAdded: false,
            isMoreFilesSynced: true,
        }
    }

    ///////////////////////////////////////////////////////////////////
    /// README: TAG CONTROL
    else if (action.type === "OPEN_NEW_TAG_MODAL") {
        return {
            ...state,
            isTagCreating: false,
            isTagCreated: false,
        }
    }
    else if (action.type === "ADD_NEW_TAG" || action.type === "UPDATE_TAG" || action.type === "DELETE_TAG") {
        return {
            ...state,
            isTagCreating: true,
        }
    }
    else if (action.type === "NEW_TAG_ADDED" || action.type === "TAG_UPDATED" || action.type === "TAG_DELETED") {
        return {
            ...state,
            isTagCreating: false,
            isTagCreated: true,
        }
    }

    /// README: PROJECT DETAIL UPDATING
    else if (action.type === "OPEN_PROJECT_UPDATE_MODAL") {
        return {
            ...state,
            isProjectUpdating: false,
            isProjectUpdated: false,
        }
    }
    else if (action.type === "UPDATE_PROJECT") {
        return {
            ...state,
            isProjectUpdating: true,
        }
    }

    else if (action.type === "PROJECT_UPDATED") {
        return {
            ...state,
            isProjectUpdating: false,
            isProjectUpdated: true,
        }
    }

    /// README: PROJECT API CALLS

    else if (action.type === "PAPI_CALL_INIT") {
        // console.log(action.papiMessage)
        return {
            ...state,
            papiMessage: action.papiMessage,
            showPapiLoader: action.showPapiLoader,
            papid: action.papid,
            papiIsDoneAndSent: action.papiIsDoneAndSent ?? false,
            isReportCreating: true,


        }
    }
    else if (action.type === "PAPI_CALL_COMPLETED" || action.type === "PAPI_CALL_ERROR") {
        // console.log(action.papiMessage)
        return {
            ...state,
            papiMessage: action.papiMessage,
            showPapiLoader: action.showPapiLoader,
            papid: action.papid,
            papiIsDoneAndSent: action.papiIsDoneAndSent ?? false,
            isReportCreating: false,
            isReportCreated: true,
            isMemberRemoved: true,
            isMemberAdded: true,
        }
    }

    else if (action.type === "OPEN_NEW_REPORT_MODAL") {
        return {
            ...state,
            isReportCreating: false,
            isReportCreated: false,
        }
    }

    else if (action.type === "OPEN_NEW_MANAGE_PROJECT_MEMBER_MODAL") {
        return {
            ...state,
            isMemberRemoved: false,
        }
    }

    else if (action.type === "OPEN_NEW_COMPANY_MEMBER_MODAL") {
        return {
            ...state,
            isMemberAdded: false,
        }
    }

    else if (action.type === "PROJECT_DELETION_START") {
        return {
            ...state,
            isProjectDeleting: true,
        }
    }
    else if (action.type === "PROJECT_DELETED") {
        return {
            ...state,
            isProjectDeleted: false,
        }
    }
    else if (action.type === "OPEN_DELETE_PROJECT_MODAL") {
        return {
            ...state,
            isProjectDeleted: true,
        }
    }
    return state;
}

export default projectReducer;
